export default __webpack_public_path__ + "static/media/zone.c6a283bb.png";